<template>
  <div id="home-screen">
    <h1 class="pt-3 top">Concord Grape Crop Load Calculator</h1>
    <Warning />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4 left-column pt-3 pb-3">
          <UserInputs />
        </div><!-- /.col-md-4 -->
        <div class="col-md-8 right-column pl-1 pt-3 pb-5">

          <!-- Vizualizations Nav Menu -->
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <span class="nav-link clickable" :class="{ active: vizMode === 'charts' }" @click="vizMode = 'charts'"><i class="far fa-chart-bar"></i> Charts</span>
            </li>
            <li class="nav-item">
              <span class="nav-link clickable" :class="{ active: vizMode === 'numbers' }" @click="vizMode = 'numbers'"><i class="fas fa-list-ol"></i> Numbers</span>
            </li>
            <li class="nav-item">
              <span class="nav-link clickable" :class="{ active: vizMode === 'trajectories' }" @click="vizMode = 'trajectories'"><i class="fas fa-chart-line"></i> Trajectories</span>
            </li>
          </ul>

          <div v-if="vizMode == 'charts'">
            <div class="row">
              <div class="col-md-6 pr-1">
                <div class="card mt-2 zone-card">
                  <YrOneClBar />
                </div><!-- /.card -->
              </div><!-- /.col-md-6 -->
              <div class="col-md-6 pl-1">
                <div class="card mt-2 zone-card">
                  <YrOneJssBar />
                </div><!-- /.card -->
              </div><!-- /.col-md-6 -->
            </div><!-- /.row -->
            <div class="row">
              <div class="col-md-6 pr-1">
                <div class="card mt-2 zone-card">
                  <YrOneCropBar />
                </div><!-- /.card -->
              </div><!-- /.col-md-6 -->
              <div class="col-md-6 pl-1">
                <div class="card mt-2 zone-card">
                  <YrTwoCropBar />
                </div><!-- /.card -->
              </div><!-- /.col-md-6 -->
            </div><!-- /.row -->
          </div><!-- charts -->

          <div v-if="vizMode == 'numbers'">
            <!-- NUMBERS QUADRANT -->
            <NumbersQuadrant />
          </div>

          <div v-if="vizMode == 'trajectories'">
            <div class="row">
              <div class="col-md-12 pr-3">
                <div class="card mt-2 zone-card">
                  <PaymentTrajectories  />
                </div><!-- /.zone-card -->
              </div><!-- /.col-md-12 -->
            </div><!-- /.row -->
          </div>

        </div><!-- /.col-md-8 -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div><!-- /#home-screen -->
</template>

<script>
import YrOneClBar from './visualizations/YrOneClBar'
import YrOneJssBar from './visualizations/YrOneJssBar'
import YrOneCropBar from './visualizations/YrOneCropBar'
import YrTwoCropBar from './visualizations/YrTwoCropBar'
import PaymentTrajectories from './visualizations/PaymentTrajectories'
import VpaCalculator from './VpaCalculator'
import NumbersQuadrant from './visualizations/NumbersQuadrant'
import Warning from './Warning'
import UserInputs from './UserInputs'

export default {
  data() {
    return {
      vizMode: 'charts'
    }
  },
  components: {
    YrOneClBar,
    YrOneJssBar,
    YrOneCropBar,
    YrTwoCropBar,
    PaymentTrajectories,
    VpaCalculator,
    NumbersQuadrant,
    Warning,
    UserInputs
  },
}
</script>



// WEBPACK FOOTER //
// src/components/HomeScreen.vue